<template>
  <div id="app">
    <section id="about" class="about" >
    <div class="about-decor">
      <div class="about-circle1"><img :src='"../../assets/images/team1-blue.png"' alt="team1"></div>
      <div class="about-circle2"><img :src='"../../assets/images/main-banner1-blue.png"' alt="banner1"></div>
    </div>
    <div class="container">
      <div class="row ">
        <div class="col-md-5">
          <div class="about-contain">
            <div>
              <h2 class="title"><span>{{ $t(`offer.steps.title1`) }}</span> {{ $t(`offer.steps.title2`) }}
              </h2>
              <div class="row sm-mb">
                <div class="col">
                  <ul class="about-style">
                    <li class="abt-hover" v-for="i in [1,2,3,4]" :key="i">
                      <div class="about-icon">
                        <div class="icon-hover">
                          <img :src="getImgUrl(i)" alt="easy-to-use">
                        </div>
                      </div>
                      <div class="about-text" style="text-align: left;">
                        <h3>{{ $t(`offer.steps.text.${i}.text`) }}</h3>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7 d-medium-none">
          <div class="about-right">
            <div class="about-phone">
              <img  :src='"../../assets/images/mediamodifier_image_2.png"' class="img-fluid" alt="aboutus">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: "StepsGetStarted",
  methods: {
    getImgUrl (image) {
      return require('../../assets/images/numbers/' + image + '.svg')
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .about-text h3 {
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offerPage/steps_get_started.vue